// Mirror of backend core/permissions.py — keep in sync.
export const ROLE_LABELS = {
  super_admin: 'Propietario / Super Admin',
  admin: 'Administrador',
  accountant: 'Contabilidad',
  dispatcher: 'Despacho',
  driver: 'Chofer',
  readonly: 'Solo lectura',
  customer_service: 'Servicio al cliente',
  insurance: 'Aseguradora (portal)',
  business: 'Empresa (portal)',
  partner: 'Aliado externo',
  customer: 'Cliente',
};

export const HOME_ROUTE = {
  super_admin: '/admin', admin: '/admin', accountant: '/accounting', dispatcher: '/dispatch',
  driver: '/driver', readonly: '/dispatch', customer_service: '/dispatch',
  insurance: '/insurance', business: '/business', partner: '/partner', customer: '/customer',
};

const READONLY_INHERITS = ['admin', 'dispatcher', 'accountant'];
const READONLY_DENY = ['/admin/security', '/admin/settings', '/admin/whatsapp', '/admin/billing/ncf-sequences', '/dispatch/nuevo'];

export const roleLabel = (role) => ROLE_LABELS[role] || (role || '').replace('_', ' ');
export const homeRoute = (user) => user?.home_route || HOME_ROUTE[user?.role] || '/dispatch';

export function canAccess(user, roles, path = '') {
  if (!user) return false;
  if (!roles || user.role === 'super_admin' || roles.includes(user.role)) return true;
  if (user.role === 'readonly') {
    if (READONLY_DENY.some(p => path.startsWith(p))) return false;
    return READONLY_INHERITS.some(r => roles.includes(r));
  }
  return false;
}

export const isReadOnly = (user) => user?.role === 'readonly' || !!user?.read_only;

export const STATUS_LABELS = { active: 'Activo', inactive: 'Desactivado', suspended: 'Desactivado', blocked: 'Bloqueado' };

export const INVITE_LABELS = { pending: 'Invitación pendiente', sent: 'Invitación enviada', activated: 'Cuenta activada', expired: 'Invitación expirada', reset_pending: 'Reset pendiente (correo falló)', reset_sent: 'Reset enviado', reset_expired: 'Enlace de reset expirado' };

export const ACTION_LABELS = {
  user_invited: 'Invitación enviada', user_invitation_resent: 'Invitación reenviada', user_account_activated: 'Cuenta activada',
  whatsapp_conversation_deleted: 'Conversación WA eliminada', whatsapp_conversation_restored: 'Conversación WA restaurada', whatsapp_conversation_purged: 'Conversación WA borrada definitivamente', whatsapp_conversation_auto_restored: 'Conversación WA auto-restaurada (nuevo mensaje)',
  user_password_reset_link_sent: 'Enlace de reset enviado', user_password_reset_completed: 'Contraseña restablecida por enlace', user_invitation_expired: 'Invitación expirada (aviso al admin)',
  user_auto_blocked: 'Bloqueo automático (intentos fallidos)', user_whatsapp_sent: 'WhatsApp manual enviado', user_activation_link_copied: 'Enlace de activación copiado',
  user_created: 'Usuario creado', user_updated: 'Usuario editado', user_role_changed: 'Rol cambiado',
  user_deactivated: 'Usuario desactivado', user_blocked: 'Usuario bloqueado', user_activated: 'Usuario activado',
  user_password_reset: 'Contraseña restablecida', user_sessions_revoked: 'Sesiones cerradas',
  session_revoked: 'Sesión revocada', password_changed: 'Contraseña cambiada',
  service_created: 'Servicio creado', service_assigned: 'Servicio asignado', service_status_changed: 'Estado de servicio',
  service_cancelled: 'Servicio cancelado', service_price_confirmed: 'Precio confirmado', service_zone_overridden: 'Zona ajustada',
  invoice_created: 'Factura creada', invoice_status_changed: 'Estado de factura', company_settings_updated: 'Config. empresa',
  payroll_settings_updated: 'Config. nómina actualizada', whatsapp_ai_settings_updated: 'Config. IA del bot WhatsApp', employee_compensation_updated: 'Ficha salarial actualizada',
  payroll_adjustment_created: 'Novedad de nómina creada', payroll_adjustment_deleted: 'Novedad de nómina eliminada',
  payroll_run_created: 'Nómina calculada', payroll_run_recalculated: 'Nómina recalculada', payroll_run_approved: 'Nómina aprobada',
  payroll_run_paid: 'Nómina pagada (asiento generado)', payroll_run_cancelled: 'Nómina cancelada',
  payslip_email_sent: 'Volante enviado por correo', payslip_email_failed: 'Envío de volante falló', payslip_link_created: 'Enlace de volante generado',
};
export const actionLabel = (a) => ACTION_LABELS[a] || a;
